export const TABLE_MENU_WIDTH = 280;
